import { Navigate, useLocation, useParams } from "react-router";
export function InvitationRecordPage() {
  const { invitationId } = useParams(); const location = useLocation(); const query = new URLSearchParams(location.search);
  if (invitationId) query.set("visit", `invitation:${invitationId}`);
  return <Navigate replace to={`/admin/invitations?${query}`} />;
}
